__turbopack_context__.v({
  "buttons": "slider-module-scss-module__NfQQQq__buttons",
  "buttons__nextButton": "slider-module-scss-module__NfQQQq__buttons__nextButton",
  "buttons__prevButton": "slider-module-scss-module__NfQQQq__buttons__prevButton",
  "image": "slider-module-scss-module__NfQQQq__image",
  "paginationDetailed": "slider-module-scss-module__NfQQQq__paginationDetailed",
  "paginationSimple": "slider-module-scss-module__NfQQQq__paginationSimple",
  "root": "slider-module-scss-module__NfQQQq__root",
  "root__swiper": "slider-module-scss-module__NfQQQq__root__swiper",
  "swiper": "slider-module-scss-module__NfQQQq__swiper",
  "video": "slider-module-scss-module__NfQQQq__video",
  "videoWrapper": "slider-module-scss-module__NfQQQq__videoWrapper",
});
